/**
 * @author xiaozhu
 * @date 21/10/25
 * @content 公共方法
 */

// import mtl from 'mtl-js-sdk';
const mtl = window.mtl || {};

/**
 * 页面跳转
 * @param {*h5 required h5路由跳转路径} path
 * @param {*wx required 微信小程序跳转路径} url
 * @param {*navigateTo跳转成功} success
 * @param {*navigateTo跳转失败} fail
 */
export const navigateTo = ({ path, url, success, fail }) => {
    let jumpPage = function (navUrl) {
        if (navUrl) {
            mtl.navigateTo({
                url:navUrl,
                // url:navUrl,
                success,
                fail,
            });
        } else {
            console.error("请核对你所输入的url地址是否正确!!!");
        }
    };
    switch (mtl.platform) {
        case "h5":
            console.log('h5 jump to ' + path);
            // jumpPage(window.location.href+ path.replace('/', ''));
            jumpPage(path);

            break;
        case "wx":
            console.log('wx jump to ' + url);
            jumpPage(url);

            break;
        default:
            break;
    }
};

/**
 * 设置缓存
 * @param {* 设置缓存的key值} key
 * @param {* 设置缓存的值} data
 */
export const setStorage = (key, data) => {
    let result;
    switch (mtl.platform) {
    case "h5":
        result = window.localStorage.setItem(key, data);
        break;
    case "wx":
        mtl.setStorage({
            key,
            data,
            success: res => {
                result = res?.data;
            },
            fail: err => {
                console.log(err);
            }
        })
        break;
    default:
        break;
    }
    return result;
};

/**
 * 获取缓存
 * @param {* 获取缓存的key值} key
 */
export const getStorage = (key) => {
    let result;
    switch (mtl.platform) {
    case "h5":
        result = window.localStorage.getItem(key);
        break;
    case "wx":
        mtl.getStorage({
            key,
            success: res => {
                result = res?.data;
            },
            fail: err => {
                console.log(err);
            }
        });
        break;
    default:
        break;
    }
    return result;
};

/**
 * 移除缓存
 * @param {* 移除缓存的key值} key
 */
export const removeStorage = (key) => {
    let result;
    switch (mtl.platform) {
    case "h5":
        result = window.localStorage.removeItem(key);
        break;
    case "wx":
        mtl.removeStorage({
            key,
            success: res => {
                result = res?.data;
            },
            fail: (err) => {
                console.log(err);
            }
        })
        break;
    default:
        break;
    }
    return result;
};

/**
 * 通过经纬度来计算两点之间的距离
 * @param {* 提供中心点的经度} centerLng
 * @param {* 提供中心点的纬度} centerLat
 * @param {* 提供目前设备所在的经度} longitude
 * @param {* 提供目前设备所在的纬度} latitude
 */

export const calculationDist = (centerLng, centerLat, longitude, latitude) => {
    if (centerLng && centerLat && longitude && latitude) {
        let readCenterLat = (centerLat * Math.PI) / 180.0;
        let readLat = (latitude * Math.PI) / 180.0;
        let horizontal = readCenterLat - readLat;
        let vertical =
        (centerLng * Math.PI) / 180.0 - (longitude * Math.PI) / 180.0;
        let result =
        2 *
        Math.asin(
            Math.sqrt(
            Math.pow(Math.sin(horizontal / 2), 2) +
                Math.cos(readCenterLat) *
                Math.cos(readLat) *
                Math.pow(Math.sin(vertical / 2), 2)
            )
        );
        result = result * 6378.137; // 地球半径
        result = Math.round(result * 10000) / 10000;
        return result * 1000; // 这里拿到的数据是以 m 为单位
    } else {
        return null;
    }
};

/**
 * 用于字符解码成unicode
 * @param {* 提供解码的字符串} str
 */
function isChinese(s) {
    return /[\u4e00-\u9fa5]/.test(s);
}
export const ch2Unicode = (str) => {
    if (!str) {
        return;
    }
    var unicode = "";
    for (var i = 0; i < str.length; i++) {
        var temp = str.charAt(i);
        if (isChinese(temp)) {
        unicode += "\\u" + temp.charCodeAt(0).toString(16);
        } else {
        unicode += temp;
        }
    }
    return unicode;
};

/**
 * 用于处理文本高亮
 * @param{* 符合包含value值的文本字符} str
 * @param{* 搜索框中输入的字符} searchText
 */

export const highlight = (str, searchText) => {
    let reg = new RegExp(searchText);
    let result = str.replace(reg, `<span class="search-dim-color">$&</span>`);
    return result;
};

function getMonthStartAndEnd(count, type){
    let currentDate = new Date();
    let month = currentDate.getMonth() + count;
    if(month < 0){
        let n = parseInt((-month)/12);
        month += n*12;
        currentDate.setFullYear(currentDate.getFullYear()-n);
    }
    currentDate = new Date(currentDate.setMonth(month));
    let currentMonth = currentDate.getMonth();
    let currentYear = currentDate.getFullYear();
    let currentMonthFirstDay = new Date(currentYear, currentMonth, 1).valueOf();
    let currentMonthLastDay = new Date(currentYear, currentMonth+1, 0).valueOf();
    switch(type){
        case 'start' : return currentMonthFirstDay;
        case 'end' : return currentMonthLastDay;
    }
}

export const startTime = (type) => {
    let date = new Date();
    let currentWeek = date.getUTCDay();
    switch(type){
        case 'week':
            return currentWeek === 0 ? 6 : currentWeek -1
        case 'month':
            return getMonthStartAndEnd(0, 'start')
        case 'lastMonth':
            return getMonthStartAndEnd(-1 ,'start')
    }
}

export const endTime = (type) => {
    let date = new Date();
    let currentWeek = date.getUTCDay();
    switch(type){
        case "week":
            return currentWeek === 0 ? 0 : 7 - currentWeek
        case 'month':
            return getMonthStartAndEnd(0, 'end')
        case 'lastMonth':
            return getMonthStartAndEnd(-1 ,'end')
    }
}

function isLeapYear(year){
    if(((year % 4 === 0) && (year % 100 !== 0))|| (year % 400 === 0)){
        return 29;
    }else{
        return 28
    }
}

export const getTime = () => {
    let month = new Date().getMonth();
    switch(month){
        case 0:
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
            return 31;
        case 4:
        case 6:
        case 9:
        case 11:
            return 30;
        case 2 : return isLeapYear(new Date().getFullYear())
    }
}

/**
 * @param {* 给数字加上千分位分隔符} data
 */
export const addSeparator = data => {
    let res=data.toString().replace(/\d+/, function(n){ // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
           return $1+",";
         });
   })
   return res;
}

/**
 * 压缩图片
 * @param file 原始图片文件
 * @param options 压缩选项
 * @returns 压缩后的 File 对象
 */
export const compressImage = (file, options = {}) => {
    const {
        maxWidth = 800,
        maxHeight = 800,
        quality = 0.8,
        maxSize = 1024 * 100 // 100KB
    } = options

    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (e) => {
            const img = new Image()
            img.src = e.target.result
            img.onload = () => {
                let { width, height } = img

                // 按比例缩放
                if (width > maxWidth) {
                    height = (maxWidth / width) * height
                    width = maxWidth
                }
                if (height > maxHeight) {
                    width = (maxHeight / height) * width
                    height = maxHeight
                }

                const canvas = document.createElement('canvas')
                canvas.width = width
                canvas.height = height
                console.log(canvas, '-----------------canvas')
                const ctx = canvas.getContext('2d')
                ctx.drawImage(img, 0, 0, width, height)

                // 转为 Blob
                canvas.toBlob((blob) => {
                    if (!blob) {
                        reject(new Error('压缩失败'))
                        return
                    }
                    // 创建新的 File 对象
                    const compressedFile = new File([blob], file.name, {
                        type: file.type || 'image/jpeg'
                    })
                    resolve(compressedFile)
                }, file.type || 'image/jpeg', quality)
            }
            img.onerror = reject
        }
        reader.onerror = reject
    })
}
